import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'
import { DialogModel } from '@/state/ui/global/models'

import {
  setDrawerAction,
  uiGlobalSelector,
} from '@/state/ui/global/slices/index.slices'

function useDrawer() {
  const dispatch = useAppDispatch()

  const { drawer } = useSelector(uiGlobalSelector)

  const handleToggleDrawer = (payload: boolean | DialogModel) => {
    dispatch(
      setDrawerAction(
        typeof payload === 'boolean' ? { open: payload } : payload,
      ),
    )
  }

  return { drawer, handleToggleDrawer }
}

export default useDrawer
